module.exports = __webpack_public_path__ + "623a27a542e54af20496076b929548dd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-23.png
// module id = 1433
// module chunks = 0